import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AccountingPeriodService } from '../../accounting-period/services/accounting-period.service';
import { DebtorServiceService } from './Services/debtor-service.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import { Router } from '@angular/router';
import { FinancialpositionService } from '../../financialposition/financialposition.service';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
@Component({
  selector: 'app-debtors',
  templateUrl: './debtors.component.html',
  styleUrls: ['./debtors.component.scss']
})
export class DebtorsComponent implements OnInit {
  DebtorsForm: FormGroup;
  debtorid: any; isJump: any;
  debtorsDueWithinOneYear: number = 0
  debtorsDueWithinOneYear_LY: number = 0
  Currentyear: any;
  flag: any;
  total: any;
  total_ly: any
  APPeriodId: any;
  balancesheetvalues: any
  debtor: any
  debtorLy: any;
  NormalRoutng: boolean;
  showBubbledata;any
  constructor(public formbuilder: FormBuilder, private dservice: DebtorServiceService, private accountsperiod: AccountingPeriodService, public commonService: CommonService, private router: Router, public balanceSheetService: FinancialpositionService, public sidenav: SideNavService) { }
  ngOnInit(): void {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders
    this.getBalanceSheetData(this.APPeriodId);
    this.createDebtors();
    this.getdebtors(this.APPeriodId);
    this.isJump = localStorage.getItem('isJump')
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastdebtor()
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})

    if (localStorage.getItem("SubmitStatus") == "true")
      this.DebtorsForm.disable()
    if (this.commonService.AccountTemplateId == 7 && localStorage.getItem("SubmitStatus") != "true") {
      this.DebtorsForm.disable()
      this.DebtorsForm.get('DebtorsFreeøtextComment')?.enable();
    }
    this.clearfield();

  }
  createDebtors() {
    this.DebtorsForm = this.formbuilder.group({
      DebtorsId: ['', []],
      APPeriodId: ['', []],
      TradeDebtorsWithinOneYear: ['', []],
      TradeDebtorsWithinOneYear_LY: ['', []],
      OtherDebtorsBalanceSheetSubtotal: ['', []],
      OtherDebtorsBalanceSheetSubtotal_LY: ['', []],
      PrepaymentsAccruedIncome: ['', []],
      PrepaymentsAccruedIncome_LY: ['', []],
      DebtorsDueWithinOneYear: ['', []],
      DebtorsDueWithinOneYear_LY: ['', []],
      //Debtors: ['', []],
      //Debtors_LY: ['', []],
      DebtorsFreeøtextComment: ['', []],
      CreatedBy: [localStorage.getItem('LoginuserId')]
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.DebtorsForm.reset()
      }
    })
  }

  getBalanceSheetData(apPeriodId) {
    debugger
    //if (this.commonService.AccountTemplateId == 11) {
    //  this.balanceSheetService.getBalanceSheetFRS101(apPeriodId).subscribe((data: any) => {
    //    this.balancesheetvalues = data;
    //    this.debtor = Math.abs(data.TradeAndOtherReceivables)
    //    this.debtorLy = Math.abs(data.TradeAndOtherReceivables_LY)
    //    this.DebtorsForm.controls['DebtorsDueWithinOneYear'].disable();
    //    this.DebtorsForm.controls['DebtorsDueWithinOneYear_LY'].disable();
    //  })
    //}
   // else {
      this.balanceSheetService.getBalanceSheet(apPeriodId).subscribe((data: any) => {
        this.balancesheetvalues = data;
        this.debtor = Math.abs(data.Debtors)
        this.debtorLy = Math.abs(data.Debtors_LY)
        this.DebtorsForm.controls['DebtorsDueWithinOneYear'].disable();
        this.DebtorsForm.controls['DebtorsDueWithinOneYear_LY'].disable();
      })

   // }
  }
  Insertdebtors() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.DebtorsForm.controls['APPeriodId'].setValue(this.APPeriodId)
    this.DebtorsForm.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    const formdata = this.DebtorsForm.getRawValue();
    if (this.debtorid) {
      this.DebtorsForm.controls['DebtorsId'].setValue(this.debtorid)
    }
    this.dservice.insertdebtor(formdata).subscribe((data) => {
      this.DebtorsForm.markAsPristine();
      if (this.NormalRoutng)
        return false;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Debtors", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == "debtors") {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }

  back() {
    this.DebtorsForm.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Debtors", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  getdebtors(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.dservice.getdebtor(this.APPeriodId).subscribe((data: any) => {
      if (data) {
        this.DebtorsForm.patchValue(data)
        this.debtorid = data.DebtorsId;
      }
      this.commonService.getNotesData();
    })
  }
  getlastdebtor() {
    this.dservice.getdebtorLY(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }
  save() {
    debugger
    if (this.validations()) {
      this.Insertdebtors();
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }


  DebtorsCalculations() {
    debugger;
    this.total = 0;
    this.total = parseFloat(((this.DebtorsForm.controls['TradeDebtorsWithinOneYear'].value == "" || this.DebtorsForm.controls['TradeDebtorsWithinOneYear'].value == null) ? 0 : this.DebtorsForm.controls['TradeDebtorsWithinOneYear'].value))
      + parseFloat(((this.DebtorsForm.controls['OtherDebtorsBalanceSheetSubtotal'].value == "" || this.DebtorsForm.controls['OtherDebtorsBalanceSheetSubtotal'].value == null) ? 0 : this.DebtorsForm.controls['OtherDebtorsBalanceSheetSubtotal'].value))
      + parseFloat(((this.DebtorsForm.controls['PrepaymentsAccruedIncome'].value == "" || this.DebtorsForm.controls['PrepaymentsAccruedIncome'].value == null) ? 0 : this.DebtorsForm.controls['PrepaymentsAccruedIncome'].value))
    this.DebtorsForm.controls["DebtorsDueWithinOneYear"].setValue(this.total);
  }

  DebtorsCalculations_LY() {
    debugger;
    this.total_ly = 0;
    this.total_ly = parseFloat(((this.DebtorsForm.controls['TradeDebtorsWithinOneYear_LY'].value == "" || this.DebtorsForm.controls['TradeDebtorsWithinOneYear_LY'].value == null) ? 0 : this.DebtorsForm.controls['TradeDebtorsWithinOneYear_LY'].value))
      + parseFloat(((this.DebtorsForm.controls['OtherDebtorsBalanceSheetSubtotal_LY'].value == "" || this.DebtorsForm.controls['OtherDebtorsBalanceSheetSubtotal_LY'].value == null) ? 0 : this.DebtorsForm.controls['OtherDebtorsBalanceSheetSubtotal_LY'].value))
      + parseFloat(((this.DebtorsForm.controls['PrepaymentsAccruedIncome_LY'].value == "" || this.DebtorsForm.controls['PrepaymentsAccruedIncome_LY'].value == null) ? 0 : this.DebtorsForm.controls['PrepaymentsAccruedIncome_LY'].value))
    this.DebtorsForm.controls["DebtorsDueWithinOneYear_LY"].setValue(this.total_ly);

  }

  validations() {
    debugger
    if (this.commonService.AccountTemplateId != 7) {
      if (this.commonService.AccountTypeId == 2) {
        if (this.commonService.showControl == true) {
          if (((this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value == "" || this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value == null) ? 0 : this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value) != (this.debtor == null ? 0 : this.debtor)) {
            Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.StartYear + " must tally with the Debtors and Prepayments and Accrued Income value in the Trial balance for the year " + this.commonService.StartYear + ".", "warning")
            return false;
          }
          else if (((this.DebtorsForm.controls['DebtorsDueWithinOneYear_LY'].value == "" || this.DebtorsForm.controls['DebtorsDueWithinOneYear_LY'].value == null) ? 0 : this.DebtorsForm.controls['DebtorsDueWithinOneYear_LY'].value) != (this.debtorLy == null ? 0 : this.debtorLy)) {
            Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.LastYear + " must tally with the Debtors and Prepayments and Accrued Income value in the Trial balance for the year " + this.commonService.LastYear + ".", "warning")
            return false;
          }
          else {
            return true;
          }
        }
        else {
          if (((this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value == "" || this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value == null) ? 0 : this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value) != (this.debtor == null ? 0 : this.debtor)) {
            Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.StartYear + " must tally with the Debtors and Prepayments and Accrued Income value in the Trial balance for the year " + this.commonService.StartYear + ".", "warning")
            return false;
          }
          else {
            return true;
          }
        }
      }
      else {
        if (this.commonService.showControl == true) {
          if (((this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value == "" || this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value == null) ? 0 : this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value) != (this.debtor == null ? 0 : this.debtor)) {
            Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.StartYear + " must tally with the Debtors value in the balance sheet for the year " + this.commonService.StartYear + ".", "warning")
            return false;
          }
          else if (((this.DebtorsForm.controls['DebtorsDueWithinOneYear_LY'].value == "" || this.DebtorsForm.controls['DebtorsDueWithinOneYear_LY'].value == null) ? 0 : this.DebtorsForm.controls['DebtorsDueWithinOneYear_LY'].value) != (this.debtorLy == null ? 0 : this.debtorLy)) {
            Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.LastYear + " must tally with the Debtors value in the balance sheet for the year " + this.commonService.LastYear + ".", "warning")
            return false;
          }
          else {
            return true;
          }
        }
        else {
          if (((this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value == "" || this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value == null) ? 0 : this.DebtorsForm.controls['DebtorsDueWithinOneYear'].value) != (this.debtor == null ? 0 : this.debtor)) {
            Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.StartYear + " must tally with the Debtors value in the balance sheet for the year " + this.commonService.StartYear + ".", "warning")
            return false;
          }
          else {
            return true;
          }
        }
      }
    }
    else {
      return true
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.DebtorsForm.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:900'>You have unsaved data.</span> <br><span>Do you want to save your changes before leaving?</span>",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        this.NormalRoutng = true;
        if (result.value) {
          this.NormalRoutng = true;
          if (this.save())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }


}
